import { render, staticRenderFns } from "./specialPeos.vue?vue&type=template&id=0ef3acba&scoped=true&"
import script from "./specialPeos.vue?vue&type=script&lang=js&"
export * from "./specialPeos.vue?vue&type=script&lang=js&"
import style0 from "./specialPeos.vue?vue&type=style&index=0&id=0ef3acba&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ef3acba",
  null
  
)

export default component.exports